import script from "./ProjectInformationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectInformationView.vue?vue&type=script&setup=true&lang=js"

import "./ProjectInformationView.vue?vue&type=style&index=0&id=d230deea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d230deea"]])

export default __exports__